exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image{\n    margin-left: 5px;\n}\n.per-set {\n    font-size: 12px;\n    color: grey;\n  }\n.padding{\n    padding: 5px;\n}\n.misc-card {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    /* align-content: center; */\n  }\n.img-misc {\n      margin-top: 50px;\n  }\n.misc-price {\n      /* background-color: #e0dddd;\n      color: black; */\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/samirjha/Project/nushing/src/app/more-product/more-product.component.css
// module id = ../../../../../src/app/more-product/more-product.component.css
// module chunks = main